var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52,
    r: 52,
    fill: "#F5B700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 58.5C48.42 58.5 45.5 55.58 45.5 52C45.5 48.42 48.42 45.5 52 45.5C55.58 45.5 58.5 48.42 58.5 52C58.5 55.58 55.58 58.5 52 58.5ZM52 48.5C50.08 48.5 48.5 50.08 48.5 52C48.5 53.92 50.08 55.5 52 55.5C53.92 55.5 55.5 53.92 55.5 52C55.5 50.08 53.92 48.5 52 48.5Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58.5C64.18 58.5 63.5 57.82 63.5 57V47C63.5 46.18 64.18 45.5 65 45.5C65.82 45.5 66.5 46.18 66.5 47V57C66.5 57.82 65.82 58.5 65 58.5Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73.5C32.76 73.5 28.5 69.24 28.5 64C28.5 58.76 32.76 54.5 38 54.5C43.24 54.5 47.5 58.76 47.5 64C47.5 69.24 43.24 73.5 38 73.5ZM38 57.5C34.42 57.5 31.5 60.42 31.5 64C31.5 67.58 34.42 70.5 38 70.5C41.58 70.5 44.5 67.58 44.5 64C44.5 60.42 41.58 57.5 38 57.5Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9998 67.4995C35.4998 67.4995 34.9998 67.2395 34.7198 66.7795C34.2998 66.0795 34.5198 65.1395 35.2398 64.7195L36.7598 63.7996C36.8998 63.7196 36.9998 63.5395 36.9998 63.3795V61.5195C36.9998 60.6995 37.6798 60.0195 38.4998 60.0195C39.3198 60.0195 39.9998 60.6995 39.9998 61.5195V63.3795C39.9998 64.5995 39.3398 65.7595 38.2998 66.3795L36.7798 67.2996C36.5398 67.4396 36.2598 67.4995 35.9998 67.4995Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62 69.5H45C44.18 69.5 43.5 68.82 43.5 68C43.5 67.18 44.18 66.5 45 66.5H62C67.72 66.5 70.5 63.72 70.5 58V46C70.5 40.28 67.72 37.5 62 37.5H42C36.28 37.5 33.5 40.28 33.5 46V58.4C33.5 59.22 32.82 59.9 32 59.9C31.18 59.9 30.5 59.22 30.5 58.4V46C30.5 38.7 34.7 34.5 42 34.5H62C69.3 34.5 73.5 38.7 73.5 46V58C73.5 65.3 69.3 69.5 62 69.5Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionPayment);
export default __webpack_public_path__ + "static/media/subscription-payment.5f029e613c3556f92876c1c09cc40ad6.svg";
export { ForwardRef as ReactComponent };